import React from 'react';
import Hero from './components/administration/proctors/Hero';
import Main from './components/administration/proctors/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const Proctors = () => {
  return (
    <div>
        <Hero />
        <Main />
        <ImportantLinksSlider />
    </div>
  )
}

export default Proctors;